import User from '../models/User';
import { parseEntities, parseEntity } from './commonConverters';
import { parseMoment } from './dateConverters';

export const SCHEMA = {
  id: (data: any) => data.id ?? data.outletUserId,
  name: (data: any) => (typeof data === 'string' ? data : (data.username ?? data.userName ?? data.outletUserName ?? null)),
  fullName: (data: any) => data.fullname ?? data.fullName ?? data.name,
  firstName: (data: any) => data.firstname ?? data.firstName,
  lastName: (data: any) => data.lastname ?? data.lastName,
  initials: 'initials',
  avatar: (data: any) => data.avatarResized || data.avatar || data.profilePicture || data.profileImageUri,
  profilePicture: 'profilePicture',
  phone: 'phone',
  secondPhone: (data: any) => data.secondPhone ?? data.phone2,
  isActive: 'isActive',
  isDeleted: 'isDeleted',
  culture: 'culture',
  hasPIN: 'hasPIN',
  gender: 'gender',
  createdOn: (data: any) => parseMoment(data.createdOn),
  creator: 'creator',
  permissions: (data: any) => data.permissionIds ?? data.permissions?.map((p: any) => p.id) ?? [],
  title: 'title',
  isGroup: 'isGroup',
};

export function parseUser(data: any): User | null {
  if (typeof data === 'string') return User.withFullName(data);
  return parseEntity(data, SCHEMA, User);
}

export function parseUsers(data: any): Array<User> {
  return parseEntities(data, SCHEMA, User);
}
